export const projectFilters = [
  { id: 'all', label: 'All Projects' },
  { id: 'backend', label: 'Backend & APIs' },
  { id: 'full-stack', label: 'Full Stack' },
  { id: 'ai', label: 'AI & Automation' },
  { id: 'research', label: 'Research' },
  { id: 'web', label: 'Web Applications' },
];

export const matchesFilter = (project, filter) => filter === 'all' || (project.tags || []).includes(filter);

export function demoLabel(url) {
  if (!url) return null;
  try {
    const hostname = new URL(url).hostname.toLowerCase();
    return ['youtube.com', 'www.youtube.com', 'm.youtube.com', 'youtu.be', 'vimeo.com', 'www.vimeo.com'].includes(hostname)
      ? 'Video Demo' : 'Live Demo';
  } catch { return null; }
}

export const projectName = (project) => project.displayTitle || project.title;
